<template>
  <v-card outlined>
    <v-card-title class="text-subtitle-1 primary--text">
      {{ budget.participant.name }}
      <v-spacer></v-spacer>

      <v-menu width="200" offset-y>
        <template #activator="{ on, attrs }">
          <v-btn v-bind="attrs" v-on="on" icon>
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-list-item @click="handleClickRemove()">
            <v-list-item-content>
              <v-list-item-title> Excluir </v-list-item-title>
            </v-list-item-content>
            <v-list-item-action>
              <v-icon>mdi-delete</v-icon>
            </v-list-item-action>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-card-title>
    <v-card-subtitle>
      <v-chip x-small label :color="statusColor" dark>
        {{ statusName }}
      </v-chip>
    </v-card-subtitle>

    <v-card-actions>
      <v-btn
        :to="{ name: 'dna-budget-details', params: { id: budget.id } }"
        color="grey lighten-3"
        small
        block
        elevation="0"
        class="primary--text"
      >
        Visualizar <v-icon color="primary" right small>mdi-open-in-new</v-icon>
      </v-btn>
    </v-card-actions>
    <v-card-actions class="pt-1" v-if="budget.status === 'ready'">
      <v-btn
        @click="handleClickDeny()"
        style="width: calc(50% - 5px)"
        :disabled="loadingAccept || loadingDeny"
        elevation="0"
        small
        color="red"
        dark
        :loading="loadingDeny"
      >
        <v-icon small>mdi-close</v-icon>
      </v-btn>
      <v-btn
        @click="handleClickAccept()"
        :loading="loadingAccept"
        :disabled="loadingAccept || loadingDeny"
        style="width: calc(50% - 5px)"
        elevation="0"
        small
        color="primary"
      >
        <v-icon small>mdi-check</v-icon>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { accept, deny } from "@/services/dna_budgets";

export default {
  mixins: [],

  components: {},

  props: {
    budget: Object,
  },

  data() {
    return {
      loadingAccept: false,
      loadingDeny: false,
    };
  },

  methods: {
    handleClickRemove() {
      this.$emit("click:remove");
    },

    async handleClickAccept() {
      this.loadingAccept = true;

      try {
        await accept(this.budget.id);
        this.$emit("change");
      } catch (error) {
        console.error(error);
        alert("error");
      } finally {
        this.loadingAccept = false;
      }
    },

    async handleClickDeny() {
      this.loadingDeny = true;

      try {
        await deny(this.budget.id);
        this.$emit("change");
      } catch (error) {
        console.error(error);
        alert("error");
      } finally {
        this.loadingDeny = false;
      }
    },
  },

  computed: {
    statusName() {
      if (this.budget.status === "draw") {
        return "Rascunho";
      }

      if (this.budget.status === "ready") {
        return "Pronto";
      }

      if (this.budget.status === "approved") {
        return "Aprovado";
      }

      if (this.budget.status === "denied") {
        return "Recusado";
      }

      return "";
    },

    statusColor() {
      if (this.budget.status === "ready") {
        return "blue";
      }

      if (this.budget.status === "approved") {
        return "green";
      }

      if (this.budget.status === "denied") {
        return "red";
      }

      return "grey";
    },
  },
};
</script>
